import { DASHBOARDS_PAGE_KEY } from './constants';
import type { TTranslations } from './types';

// TODO: l10n review — translations are functional equivalents of the Spanish source
export const pt: TTranslations = {
  [DASHBOARDS_PAGE_KEY]: {
    // Page header
    PAGE_TITLE: 'Dashboards',
    PAGE_SUBTITLE:
      'Visualize o pulso geral da sua organização nos principais módulos ativos.',
    // Header actions
    FRESHNESS_PREFIX: 'Última atualização:',
    FRESHNESS_REFRESH_LABEL: 'Atualizar dashboard',

    // Breadcrumbs
    BREADCRUMB_1: 'Analítica',
    BREADCRUMB_2: 'Estatísticas',
    BREADCRUMB_3: 'Dashboards',

    // Section tags
    SECTION_A_PERIOD_TAG: 'Últimos 30 dias',
    SECTION_C_PERIOD_TAG: 'Mês atual',
    SECTION_C_PERIOD_TOOLTIP:
      'Atividade do mês em curso, contabilizada desde o primeiro dia do mês até hoje. Não representa os últimos 30 dias do calendário.',

    // Section headings
    SECTION_A_HEADING: 'Métricas-chave',
    SECTION_B_HEADING: 'Tendências',
    SECTION_C_HEADING: 'Pulso por módulo',
    SECTION_D_HEADING: 'Ações recomendadas',
    SECTION_E_HEADING: 'Destaques do mês',

    // Sections
    SECTION_PLACEHOLDER: 'Conteúdo em breve',

    // Section A — KPI cards
    SECTION_A_CARD_1_DESC: 'Colaboradores ativos',
    SECTION_A_CARD_1_HELP:
      'Colaboradores com status ativo na sua organização (sem data de saída). Fonte: Gestão / HRIS (Centralizada). O sparkline mostra as ativações diárias dos últimos 30 dias e o delta compara a última semana vs a anterior.',
    SECTION_A_CARD_2_DESC: '% Colaboradores com login nos últimos 30 dias',
    SECTION_A_CARD_2_HELP:
      'Porcentagem de colaboradores ativos que fizeram login pelo menos uma vez nos últimos 30 dias. É o proxy de adoção real da plataforma. O delta compara com o mesmo cálculo do mês anterior.',
    SECTION_A_CARD_3_DESC: 'Crescimento headcount últimos 3 meses',
    SECTION_A_CARD_3_HELP:
      'Diferença líquida de colaboradores: headcount atual vs há 3 meses (entradas menos saídas). O sparkline mostra as ativações mensais dos últimos 12 meses. Fonte: HRIS (Centralizada).',

    // Section B — Trend cards
    SECTION_B_CARD_1_TITLE: 'Atividade da plataforma',
    SECTION_B_CARD_1_DESC:
      'Usuários únicos por dia · Eventos de login (Centralizada)',
    SECTION_B_CARD_1_HELP:
      'Usuários únicos que fizeram login a cada dia (eventos de login · Centralizada). Compara o período atual com o anterior; os dias sem atividade contam como 0. Média, pico e mínimo são calculados sobre o período atual.',
    SECTION_B_CARD_2_TITLE: 'Composição de atividade',
    SECTION_B_CARD_2_DESC: 'Ações por módulo · delta vs mês anterior',
    SECTION_B_CARD_2_HELP:
      'Ações registradas por cada módulo durante o período, com sua variação vs o período anterior. Cada barra é calculada de forma independente com os dados de atividade do seu próprio módulo.',
    SECTION_B_MONTH_FILTER: 'Maio 2026',

    // Section C — Module cards
    SECTION_C_MODULE_LEARNING: 'Aprendizagem',
    SECTION_C_MODULE_TALENT: 'Talent',
    SECTION_C_MODULE_RECRUITMENT: 'Recrutamento',
    SECTION_C_MODULE_COMMUNICATIONS: 'Comunicações',
    SECTION_C_MODULE_LEARNING_HELP:
      'Progresso global = progresso médio dos cursos atribuídos. Cursos concluídos soma catálogo próprio + Crehana no mês. Satisfação = média (1–5) das pesquisas de fim de curso do período. Mesma fonte que os relatórios centralizados.',
    SECTION_C_MODULE_TALENT_HELP:
      'Processos ativos = todos os processos em andamento ou iniciados (Competências, Metas, Clima, OKRs e PID), independentemente de quando foram criados. Feedbacks = realizados durante o período.',
    SECTION_C_MODULE_RECRUITMENT_HELP:
      'Vagas abertas = vagas publicadas atualmente. Candidatos em processo = candidatos únicos por vaga (não duplicados por recrutador).',
    SECTION_C_MODULE_COMMUNICATIONS_HELP:
      'Atividade mensal do módulo de Comunicações: publicações do período e interações (reações + comentários).',

    // Section D — Recommended actions
    SECTION_D_ALERTS_TITLE: 'Alertas que precisam de atenção',
    SECTION_D_ALERTS_HELP:
      'Contagens acionáveis calculadas ao vivo e ordenadas por severidade: cursos obrigatórios vencidos ou prestes a vencer com baixo progresso, avaliações com baixa participação ou pendentes de encerramento pelo líder, atribuições sem início (+14 dias), férias pendentes e relatórios programados prestes a executar.',
    SECTION_D_FILTER_ALL: 'Todas',

    // Section E — Highlight cards
    SECTION_E_CARD_1_TITLE: 'Top 5 cursos mais concluídos',
    SECTION_E_CARD_1_DESC: 'Este mês · 14 abr – 14 mai',
    SECTION_E_CARD_1_HELP:
      'Concluído = o colaborador finalizou 100% dos módulos do curso no período. As horas refletem reprodução real (minutos de progresso), não a duração do curso. Para certificação final, veja o marco Certificados emitidos.',
    SECTION_E_CARD_2_TITLE: 'Áreas com mais colaboradores ativos',
    SECTION_E_CARD_2_DESC: '% colab com login últimos 30 dias · Este mês',
    SECTION_E_CARD_2_HELP:
      'Porcentagem de colaboradores de cada área com pelo menos um login nos últimos 30 dias, ordenado de maior para menor adoção. Usa o mesmo cálculo que o KPI de login da parte superior, segmentado por área.',
    SECTION_E_CARD_3_TITLE: 'Marcos alcançados este mês',
    SECTION_E_CARD_3_DESC: 'Conquistas do período 14 abr – 14 mai',
    SECTION_E_CARD_3_HELP:
      'Conquistas do período comparadas com o mês anterior: horas de estudo, certificados emitidos, processos de avaliação encerrados, PIDs gerados e novas licenças ativadas.',

    // Empty state
    EMPTY_TITLE: 'Você ainda não tem módulos para exibir',
    EMPTY_CTA: 'Falar com vendas',

    // Error state
    ERROR_BANNER: 'Não foi possível carregar o dashboard.',
    ERROR_RETRY: 'Tentar novamente',

    // Recommended actions states
    RECOMMENDED_EMPTY: 'Não há ações recomendadas por agora.',
    RECOMMENDED_NO_ALERTS: 'Não há alertas pendentes',
    RECOMMENDED_ERROR: 'Não foi possível carregar as ações recomendadas.',

    // Recommended actions — alert titles
    ALERT_OVERDUE_COURSES_TITLE: 'Cursos obrigatórios vencidos',
    ALERT_EXPIRING_COURSES_TITLE:
      'Cursos obrigatórios prestes a vencer com baixo progresso',
    ALERT_LOW_EVAL_PARTICIPATION_TITLE:
      'Processos de avaliação com baixa participação',
    ALERT_PENDING_CALIBRATION_TITLE:
      'Avaliações pendentes de encerramento pelo líder',
    ALERT_UNSTARTED_PATHS_TITLE:
      'Trilhas/cursos atribuídos sem início (mais de 14 dias)',
    ALERT_LEADERS_NO_EVAL_TITLE:
      'Líderes com equipes sem avaliação neste ciclo',
    ALERT_PENDING_VACATIONS_TITLE:
      'Solicitações de férias pendentes de aprovação',
    ALERT_UPCOMING_REPORTS_TITLE:
      'Relatórios programados prestes a serem executados',

    // Recommended actions — alert sublabels ({{count}} interpolated)
    ALERT_OVERDUE_COURSES_SUBLABEL:
      '{{count}} colaboradores com cursos obrigatórios vencidos · Impacto em compliance',
    ALERT_EXPIRING_COURSES_SUBLABEL:
      '{{count}} colaboradores têm cursos obrigatórios que vencem em menos de 7 dias com menos de 50% de progresso · Hora de agir',
    ALERT_LOW_EVAL_PARTICIPATION_SUBLABEL:
      '{{count}} processos do Q2 com menos de 50% de resposta a 7 dias do encerramento · Performance + Clima',
    ALERT_PENDING_CALIBRATION_SUBLABEL:
      '{{count}} avaliações aguardando calibração final do líder · 6 dias para o encerramento do trimestre',
    ALERT_UNSTARTED_PATHS_SUBLABEL:
      '{{count}} colaboradores com trilhas atribuídas que não iniciaram · Considere reativar',
    ALERT_LEADERS_NO_EVAL_SUBLABEL:
      '{{count}} líderes sem enviar avaliações da equipe · Ainda pendente do ciclo Q2',
    ALERT_PENDING_VACATIONS_SUBLABEL:
      '{{count}} solicitações na sua org · Aprovação de líderes (somente visibilidade)',
    ALERT_UPCOMING_REPORTS_SUBLABEL:
      '{{count}} relatórios são executados nas próximas 24h · Revise destinatários e filtros',

    // Permission
    TOAST_NO_PERMISSION: 'Você não tem permissão para ver Dashboards',

    // CTA strip
    CTA_TITLE: 'Quer ir mais fundo?',
    CTA_SUBTITLE:
      'Gere um relatório personalizado em Acompanhamentos na Reportagem.',
    CTA_BUTTON: 'Criar relatório personalizado',

    // KPI card body
    KPI_DELTA_WOW: 'vs semana anterior',
    KPI_DELTA_MOM: 'vs mês anterior',
    KPI_DELTA_NET: 'líquido últimos 3 meses',
    KPI_NET_LABEL: 'colaboradores líquidos',
    KPI_ERROR: 'Não foi possível carregar esta métrica.',
    KPI_SPARKLINE_A11Y: 'Tendência dos últimos 30 dias',

    // Activity composition card (ANLT-168)
    // title + subtitle são BE-authoritatives (vêm em response.title / response.subtitle)
    ACTIVITY_COMPOSITION_LOADING_LABEL: 'Carregando composição de atividade',
    ACTIVITY_COMPOSITION_ERROR:
      'Não foi possível carregar a composição de atividade.',
    ACTIVITY_COMPOSITION_RETRY: 'Tentar novamente',
    ACTIVITY_COMPOSITION_EMPTY: 'Sem módulos adicionais contratados',
    ACTIVITY_COMPOSITION_SUBHEADING: 'Ações de alto volume',

    // Module pulse card footer
    MODULE_VER_DETALLE: 'Ver detalhe',

    // Activity chart series
    ACTIVITY_SERIES_CURRENT: 'Mês atual',
    ACTIVITY_SERIES_PREVIOUS: 'Mês anterior',

    // Activity stats bar
    ACTIVITY_STAT_AVG: 'Média',
    ACTIVITY_STAT_AVG_UNIT: 'usuários/dia',
    ACTIVITY_STAT_PEAK: 'Pico',
    ACTIVITY_STAT_MIN: 'Mínimo',
    ACTIVITY_DELTA_LABEL: 'vs mês anterior',

    // Top courses ranking — metrics
    TOP_COURSES_COMPLETED: '{{count}} concluídos',
    TOP_COURSES_AVG_HOURS: '{{hours}} h média',
    // Top courses ranking — states
    TOP_COURSES_TOOLTIP:
      'Concluído = colaborador finalizou 100% dos módulos do curso',
    TOP_COURSES_EMPTY: 'Ainda não há cursos concluídos este mês',
    TOP_COURSES_ERROR: 'Não foi possível carregar o ranking de cursos',
    TOP_COURSES_RETRY: 'Tentar novamente',

    // Areas engagement bars — states
    AREAS_ENGAGEMENT_EMPTY: 'Ainda não há dados de atividade por área',
    AREAS_ENGAGEMENT_ERROR: 'Não foi possível carregar a atividade por área',
    AREAS_ENGAGEMENT_RETRY: 'Tentar novamente',

    // Tooltip accessibility
    HELP_TOOLTIP_LABEL: 'Mais informações',

    // Section E — Milestones
    // TODO: l10n review
    MILESTONES_TITLE: 'Conquistas do mês',
    MILESTONES_PERIOD: 'Conquistas do período 14 abr – 14 mai',
    MILESTONE_STUDY_HOURS: 'horas de estudo concluídas',
    MILESTONE_CERTIFICATIONS: 'certificados emitidos',
    MILESTONE_TALENT_PROCESSES: 'processos de avaliação encerrados',
    MILESTONE_PIDS: 'PIDs gerados',
    MILESTONE_LICENSES: 'novas licenças ativadas',
    MILESTONES_ERROR: 'Não foi possível carregar as conquistas.',
    MILESTONES_RETRY: 'Tentar novamente',
  },
};
